import {
  httpGet,
  httpPost,
  httpPatch,
  httpPatchMerge,
  httpDelete,
} from './../http'
import type { TEntityId } from '~/types/models'
import type { IOpportunityStage } from '~/types/opportunity/models'

const apiEntityPath = '/api/opportunitystages'

export async function getOpportunityStages() {
  const callingMn = getOpportunityStages.name
  const apiPath = `${apiEntityPath}`
  const rawList = await httpGet<IOpportunityStage[]>({ callingMn, apiPath })
  return rawList.sort((a, b) => a.seqNum - b.seqNum)
}

export async function createOpportunityStage(entity: IOpportunityStage) {
  const callingMn = createOpportunityStage.name
  const apiPath = apiEntityPath
  return httpPost<IOpportunityStage>({ callingMn, apiPath, entity })
}

export async function updateOpportunityStage(
  entityData: Partial<IOpportunityStage>,
  id: TEntityId
) {
  const callingMn = updateOpportunityStage.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialOpportunityStage = Partial<IOpportunityStage>
  return httpPatchMerge<TPartialOpportunityStage>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function updateOpportunityStageSeqNums(
  updateData: Partial<IOpportunityStage>[]
) {
  const callingMn = updateOpportunityStageSeqNums.name
  const apiPath = apiEntityPath
  return httpPatch({
    callingMn,
    apiPath,
    entityData: updateData,
  })
}

export async function deleteOpportunityStage(entityData: IOpportunityStage) {
  const callingMn = deleteOpportunityStage.name
  const apiPath = apiEntityPath
  return httpDelete({
    callingMn,
    apiPath,
    entityData,
  })
}
